import passionImg from '../../../public/svg/keyStrenghts//v2/passion.svg';
import levelingUp from '../../../public/svg/keyStrenghts/v2/leveling-up.svg';
import qualityImg from '../../../public/svg/keyStrenghts/v2/quality.svg';
import teamworkImg from '../../../public/svg/keyStrenghts/v2/teamwork.svg';
import transparencyImg from '../../../public/svg/keyStrenghts/v2/transparency.svg';
import workLifeBalanceImg from '../../../public/svg/keyStrenghts/v2/work-life-balance.svg';

export const keyStrengthsData = {
  mainText: `Why Work With Us?`,
  description: `At Rumble Fish, we’re not just a team—we’re a crew of unique, talented individuals who bring out the best in each other. We play to our strengths, support each other, and chase a common goal: building awesome things together.`,
  services: [
    {
      title: `Always Leveling Up`,
      description: `Growth is the name of the game. Whether it’s taking a course, listening to a killer podcast, or diving into something new, we back you up—with a budget to match.`,
      img: `${levelingUp}`,
    },
    {
      title: `Teamwork FTW`,
      description: `We’ve got each other’s backs. Need a helping hand? Advice? Your teammates are here for you.`,
      img: `${teamworkImg}`,
    },
    {
      title: 'Work + Life = Balance',
      description: `We know happy, well-rested people do their best work. So yeah, we actually care about work-life balance.`,
      img: `${workLifeBalanceImg}`,
    },
    {
      title: `Keeping It Real`,
      description: `We believe in clean code, smooth workflows, and transparency. No unnecessary chaos—just solid teamwork and clear processes.`,
      img: `${transparencyImg}`,
    },
    {
      title: `Quality Obsessed`,
      description: `We don’t just build things—we build them right. High-quality work isn’t a nice-to-have, it’s our standard.`,
      img: `${qualityImg}`,
    },
    {
      title: `Passion-Driven`,
      description: `We hire people who love what they do. If you bring the passion, you’ll fit right in.`,
      img: `${passionImg}`,
    },
  ],
};
